import { reactive } from "@vue/composition-api"
import { debounce } from 'lodash'

const Store = () => {
  const state = reactive({
    width: innerWidth,
    height: innerHeight,
    scrollY: 0
  })

  const debouncedReiszeHandler = debounce(
    () => {
      state.width = innerWidth
      state.height = innerHeight
    }
  )
  addEventListener('resize', debouncedReiszeHandler)

  const debouncedScrollHandler = debounce(
    () => {
      state.scrollY = scrollY
    },
    0
  )
  addEventListener('scroll', debouncedScrollHandler)

  return state
}

let store = null
export default () => store || (store = Store())
